/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2020-01-17 15:03:45
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Button } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import empty from 'src/assets/images/filter-tree/empty-option.png';

import { routes } from 'src/routes';
import history from 'src/routes/history';

type Props = WithI18nProps;
// DONE
class NoRules extends Component<Props> {
  render() {
    const { i18n } = this.props;
    return (
      <div className="BC-EmptyRules__Merchandising">
        <img src={empty} alt="Empty" />
        <p style={{ padding: '12px 0' }}>
          {i18n.translate('AdminHTML.Merchandising.NoRules.paragraph')}
        </p>
        <div style={{ padding: '0.75rem 1rem' }}>
          <Button
            primary
            onClick={() => {
              history.push(routes.merchandising.new());
            }}>
            {i18n.translate('AdminHTML.Common.Action.add')}
          </Button>
        </div>
      </div>
    );
  }
}

export default withI18n()(NoRules);
